import { fetch, Method } from 'core/api/fetch';

const UnitsRoutes = {
    create: () => `/api/v1.1.1/experiencer/units`,
    list: () => `/api/v1.1.1/experiencer/units`,
    get: (unitId) => `/api/v1.1.1/experiencer/units/${unitId}`,
    update: (unitId) => `/api/v1.1.1/experiencer/units/${unitId}`,
    delete: (unitId) => `/api/v1.1.1/experiencer/units/${unitId}`,
};

export const UnitsService = {
    create: async (unitData) => {
        try {
            const url = UnitsRoutes.create();
            const { data } = await fetch(url, {
                method: Method.POST,
                authenticated: true,
                data: unitData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return data?.[0] || data;
        } catch (err) {
            throw new Error(err);
        }
    },

    list: async () => {
        try {
            const { data } = await fetch(UnitsRoutes.list(), {
                method: Method.GET,
                authenticated: true,
            });
            return data || [];
        } catch (err) {
            throw new Error(err);
        }
    },

    get: async (unitId) => {
        try {
            const { data } = await fetch(UnitsRoutes.get(unitId), {
                method: Method.GET,
                authenticated: true,
            });
            return data?.[0] || data;
        } catch (err) {
            throw new Error(err);
        }
    },

    update: async (unitId, unitData) => {
        try {
            const { data } = await fetch(UnitsRoutes.update(unitId), {
                method: Method.PATCH,
                authenticated: true,
                data: unitData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return data?.[0] || data;
        } catch (err) {
            throw new Error(err);
        }
    },

    delete: async (unitId) => {
        try {
            const { data } = await fetch(UnitsRoutes.delete(unitId), {
                method: Method.DELETE,
                authenticated: true,
            });
            return data?.[0] || data;
        } catch (err) {
            throw new Error(err);
        }
    },
};
